
import { africa, africaImages, europe, europeImages } from "../../_helpers/places";
import { SliderCarousel } from "../../components/carousels/slider-carousel";
import { Header } from "../../components/header/header";
import { NavBar } from "../../components/nav";
//import { SwiperComp } from "../swiper-comp";

export const Carousels = () => {
    return(
        <div className="page-body">
            <Header />
            <NavBar />
            <SliderCarousel data={europeImages} continent={europe} />
            <SliderCarousel data={africaImages} continent={africa} />
        </div>
    )
}